import { render, staticRenderFns } from "./commonLayout.vue?vue&type=template&id=094b2e2a&scoped=true"
import script from "./commonLayout.vue?vue&type=script&lang=js"
export * from "./commonLayout.vue?vue&type=script&lang=js"
import style0 from "./commonLayout.vue?vue&type=style&index=0&id=094b2e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094b2e2a",
  null
  
)

export default component.exports